// apps/curbpass/src/routes/vehicles/vehicleOptions.ts
import { LicensePlateState, VehicleType, VehicleCategory } from "@app.automotus.io/components/common";

export interface VehicleSelectOption {
  value: string;
  label: string;
  group?: string;
}

export const STATE_OPTIONS: VehicleSelectOption[] = LicensePlateState.All.map((s) => ({
  value: s.abbreviation,
  label: `${s.abbreviation} — ${s.fullName}`,
  group: s.countryCode === "US" && s.abbreviation !== "PR" ? "United States" : "Canada & Territories",
}));

export const VEHICLE_TYPE_OPTIONS: VehicleSelectOption[] = VehicleType.All.map((vt) => ({
  value: vt.value,
  label: vt.label,
}));

export const VEHICLE_CATEGORY_OPTIONS: VehicleSelectOption[] = VehicleCategory.All.map((vc) => ({
  value: vc.value,
  label: vc.label,
}));
